import { service } from "../utils/request";

// h后台配置项
export function publicSet(data) {
  return service({
    url: "api/tool/net_index",
    method: "post",
    data: data,
  });
}
// h后台配置项(新)
export function new_publicSet(data) {
  return service({
    url: "manage/config.config/index",
    method: "post",
    data: data,
  });
}
// 员工页面权限
export function pageSet(data) {
  return service({
    url: "offlinestore/agent.employee/get_auth",
    method: "post",
    data: data,
  });
}
// 音响
// 保存配置信息
export function setAround(data) {
  return service({
    url: "/api/config.loudspeaker/saveConfig",
    method: "post",
    data: data,
  });
}

//获取音箱配置信息
export function getAround(data) {
  return service({
    url: "/api/config.loudspeaker/index",
    method: "post",
    data: data,
  });
}

// 打印机
// 获取打印机配置信息
export function getPrinter(data) {
  return service({
    url: "/api/config.printer/detail",
    method: "post",
    data: data,
  });
}

// 保存打印机配置信息
export function setPrinter(data) {
  return service({
    url: "/api/config.printer/edit",
    method: "post",
    data: data,
  });
}
// 获取打印设置列表
export function getPrinterList(data) {
  return service({
    url: "/api/config.printer/lists",
    method: "post",
    data: data,
  });
}
// 添加打印设置
export function addPrinter(data) {
  return service({
    url: "/api/config.printer/add",
    method: "post",
    data: data,
  });
}
// 获取打印设置
export function detailPrinter(data) {
  return service({
    url: "/api/config.printer/detail",
    method: "post",
    data: data,
  });
}
// 编辑打印设置
export function editPrinter(data) {
  return service({
    url: "/api/config.printer/edit",
    method: "post",
    data: data,
  });
}
export function set_offline_detail(data) {
  return service({
    url: "manage/config.config/offline_detail",
    method: "post",
    data, 
  });
}
export function offline_setting(data) {
  return service({
    url: "manage/config.config/offline_setting",
    method: "post",
    data, 
  });
}
export function set_channel_detail(data) {
  return service({
    url: "manage/config.config/channel_setting",
    method: "post",
    data, 
  });
}
export function get_channel_detail(data) {
  return service({
    url: "manage/config.config/channel_detail",
    method: "post",
    data, 
  });
}

//如意设置
//如意列表
export function ruyiList(data) {
  return service({
    url: "manage/config.bind_lite/bind_list",
    method: "post",
    data: data,
  });
}
//解绑
export function ruyiDel(data) {
  return service({
    url: "manage/config.bind_lite/unbind",
    method: "post",
    data: data,
  });
}
//绑定
export function ruyiAdd(data) {
  return service({
    url: "manage/config.bind_lite/bind",
    method: "post",
    data: data,
  });
}

// 获取亲属卡配置信息
export function getFamily(data) {
  return service({
    url: "/user/agent.config_family_card/getConfig",
    method: "post",
    data: data,
  });
}

// 保存亲属卡配置信息
export function setFamily(data) {
  return service({
    url: "/user/agent.config_family_card/setConfig",
    method: "post",
    data: data,
  });
}

// 获取教学文章列表
export function getTeachList(data) {
  return service({
    url: "/api/Content/lists",
    method: "post",
    data: data,
  });
}

// 获取教学文章类型
export function getTeachType(data) {
  return service({
    url: "/api/Content/get_cate",
    method: "post",
    data: data,
  });
}

// 获取短信设置
export function getSMSConfig(data) {
  return service({
    url: "/api/sms/smsConfig",
    method: "post",
    data: data,
  });
}

// 申请短信账号
export function applySMS(data) {
  return service({
    url: "/api/sms/apply",
    method: "post",
    data: data,
  });
}

// 已选择的短信模板列表
export function mySMSTemplate(data) {
  return service({
    url: "/api/sms/chooseList",
    method: "post",
    data: data,
  });
}

// 短信模板库列表
export function allSMSTemplate(data) {
  return service({
    url: "/api/sms/systemTpl",
    method: "post",
    data: data,
  });
}

// 选择添加短信模板
export function selectSMSTemplate(data) {
  return service({
    url: "/api/sms/choose",
    method: "post",
    data: data,
  });
}

// 选择添加短信模板
export function delSMSTemplate(data) {
  return service({
    url: "/api/sms/delChoose",
    method: "post",
    data: data,
  });
}

// 购买短信价格
export function SMSPrice(data) {
  return service({
    url: "/api/sms/price",
    method: "post",
    data: data,
  });
}

// 支付二维码链接
export function SMSQrcode(data) {
  return service({
    url: "/api/sms/feeQrcode",
    method: "post",
    data: data,
  });
}

// 短信发送记录
export function SMSSendLogs(data) {
  return service({
    url: "/api/sms/sendLogs",
    method: "post",
    data: data,
  });
}

// 短信充值记录
export function SMSOrderList(data) {
  return service({
    url: "/api/sms/orderList",
    method: "post",
    data: data,
  });
}

// 短信详情
export function SMSOrderDetail(data) {
  return service({
    url: "/api/sms/orderDetail",
    method: "post",
    data: data,
  });
}
// 获取小程序信息
export function GetMiniInfo(data) {
  return service({
    url: "/wechat/agent.index/miniConfig",
    method: "post",
    data: data,
  });
}

// 后台管理员发验证码
export function SendAdminCode(data) {
  return service({
    url: "/user/agent.user/send_sms",
    method: "post",
    data: data,
  });
}

// 验证码安全设置
export function set_safe(data) {
  return service({
    url: "/api/config.safe/setConfig",
    method: "post",
    data: data,
  });
}

// 安全验证详情
export function get_safeinfo(data) {
  return service({
    url: "/api/config.safe/config",
    method: "post",
    data: data,
  });
}

// 群发营销短信
export function smsSendGroup(data) {
  return service({
    url: "api/sms/sendGroup",
    method: "post",
    data: data,
  });
}
// 群发营销短信
export function smsSendGroupLog(data) {
  return service({
    url: "api/sms/groupLogs",
    method: "post",
    data: data,
  });
}
// 自定义短信模板
export function addTemplate(data) {
  return service({
    url: "api/sms/addTemplate",
    method: "post",
    data: data,
  });
}
// 优惠券到期时间
export function discountPastConfig(data) {
  return service({
    url: "coupon/agent.coupon_tips_config/setConfig",
    method: "post",
    data: data,
  });
}

// 优惠券到期时间
export function discountPastDetail(data) {
  return service({
    url: "coupon/agent.coupon_tips_config/index",
    method: "post",
    data: data,
  });
}

// 获取用户端页面开关设置
export function getConfigButton(data) {
  return service({
    url: "api/config.button/index",
    method: "post",
    data: data,
  });
}

// 保存用户端页面开关设置
export function setConfigButton(data) {
  return service({
    url: "api/config.button/setButton",
    method: "post",
    data: data,
  });
}
// 获取用户端页面POS开关设置
export function getConfigButtonPos(data) {
  return service({
    url: "/api/config.Pos_Button/index",
    method: "post",
    data: data,
  });
}

// 保存用户端页面POS开关设置
export function setConfigButtonPos(data) {
  return service({
    url: "/api/config.Pos_Button/setButton",
    method: "post",
    data: data,
  });
}

// 补单
export function define_print(data) {
  return service({
    url: "/api/tool/define_print",
    method: "post",
    data: data,
  });
}
// 交班设置
export function duty_config(data) {
  return service({
    url: "offlinestore/agent.changeduty/duty_config",
    method: "post",
    data: data,
  });
}
// 通联多账户设置
export function tlpay_config(data) {
  return service({
    url: "manage/tl.tlpay/set_daily_collection_ceiling",
    method: "post",
    data: data,
  });
}
// 通联账户列表
export function tlpay_list(data) {
  return service({
    url: "manage/tl.tlpay/member_list",
    method: "get",
    params: data,
  });
}
// 是否展示订单
export function set_is_search(data) {
  return service({
    url: "manage/tl.tlpay/set_is_search",
    method: "post",
    data: data,
  });
}
// 获取商户号
export function get_search_biz_user_id(data) {
  return service({
    url: "manage/tl.tlpay/get_search_biz_user_id",
    method: "get",
    params: data,
  });
}
//设置收款顺序
export function set_sorts(data) {
  return service({
    url: "manage/tl.tlpay/set_biz_user_id_sorts",
    method: "post",
    data: data,
  });
}
export function getmember_authorization_status(data) {
  return service({
    url:
      "manage/tl.tlpay/check_app_normal_allinpay_member_authorization_status",
    method: "post",
    data: data,
  });
}
export function privacy_set(data) {
  return service({
    url: "manage/config.config/privacy_set",
    method: "post",
    data: data,
  });
}
export function privacy(data) {
  return service({
    url: "manage/config.config/privacy",
    method: "post",
    data: data,
  });
}
export function get_biz_user_id(data) {
  return service({
    url: "manage/tl.tlpay/get_biz_user_id",
    method: "get",
    params: data,
  });
}
// 获取当前支付方式
export function get_pay_name(data) {
  return service({
    url: "manage/config.config/pay_name",
    method: "post",
    data,
  });
}
// lakala配置列表
export function get_lakala_list(data) {
  return service({
    url: "manage/config.config/lakala",
    method: "post",
    data,
  });
}
// lakala配置列表
export function get_leshua_list(data) {
  return service({
    url: "manage/config.config/leshua",
    method: "post",
    data,
  });
}
// lakala配置编辑
export function get_lakala_edit(data) {
  return service({
    url: "manage/config.config/lakala_edit",
    method: "post",
    data,
  });
}
// leshua配置编辑
export function get_leshua_edit(data) {
  return service({
    url: "manage/config.config/leshua_edit",
    method: "post",
    data,
  });
}

export function getImageBase64Code(data) {
  return service({
    url: "api/tool/verify_img",
    method: "post",
    data, 
  });
}
